/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_6_TitleInputs */

const en_terms_section_6_title = /** @type {(inputs: Terms_Section_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contact Form & Communications`)
};

const lv_terms_section_6_title = /** @type {(inputs: Terms_Section_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontaktforma un komunikācija`)
};

/**
* | output |
* | --- |
* | "6. Contact Form & Communications" |
*
* @param {Terms_Section_6_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_6_title = /** @type {((inputs?: Terms_Section_6_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_6_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_6_title(inputs)
	return en_terms_section_6_title(inputs)
});